import { render, staticRenderFns } from "./device-info.vue?vue&type=template&id=68f7568a&"
import script from "./device-info.vue?vue&type=script&lang=js&"
export * from "./device-info.vue?vue&type=script&lang=js&"
import style0 from "./device-info.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\公司文件\\web\\uni-platform\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68f7568a')) {
      api.createRecord('68f7568a', component.options)
    } else {
      api.reload('68f7568a', component.options)
    }
    module.hot.accept("./device-info.vue?vue&type=template&id=68f7568a&", function () {
      api.rerender('68f7568a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/router/views/device-manage/device-list/device-info.vue"
export default component.exports